"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDWordWrap = void 0;
var TDWordWrap;
(function (TDWordWrap) {
    TDWordWrap["DEFAULT"] = "";
    TDWordWrap["NO_WRAP"] = "no-wrap-td";
    TDWordWrap["WORD_WRAP_ANYWHERE"] = "word-wrap-anywhere-td";
})(TDWordWrap = exports.TDWordWrap || (exports.TDWordWrap = {}));
var TDCssClasses;
(function (TDCssClasses) {
    TDCssClasses["BOLDED"] = "bolded-td";
    TDCssClasses["OPAQUE"] = "opaque-td";
    TDCssClasses["NO_WRAP"] = "no-wrap-td";
    TDCssClasses["ICON"] = "icon-td";
    TDCssClasses["BUTTON"] = "button-td";
    TDCssClasses["WORD_WRAP_ANYWHERE"] = "word-wrap-anywhere-td";
})(TDCssClasses || (TDCssClasses = {}));
exports.default = TDCssClasses;
//# sourceMappingURL=TDCssClasses.js.map